'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('Client', ['Role', function (Role) {
    class Client extends Role {
        isAuthorizedToUpdateOrder(order) {
            return order && order.editable;
        }

        isAuthorizedToCreateOrderNotification(order) {
            return order && order.editable;
        }

        isAuthorizedToCreateOrderLineItem(order) {
            return order && order.editable;
        }

        isAuthorizedToUpdateLineItem(order) {
            return order && order.editable;
        }

        isAuthorizedToDeleteLineItem(lineItem, order) {
            return this._isAuthorizedToDeleteLineItem && lineItem && lineItem.deletable && order && order.editable;
        }

        isAuthorizedToCopyLineItem(order) {
            return order && order.editable;
        }

        isAuthorizedToUpdateLineItemCampaignManager(order) {
            return order && order.editable;
        }

        isAuthorizedToCopyFlight(order) {
            return order && order.editable;
        }

        isAuthorizedToUpdateFlight(order) {
            return order && order.editable;
        }

        isAuthorizedToDeleteFlight(order) {
            return order && order.editable;
        }
    }

    return Client.newFrozenInstance(
        'ListClusters',
        'ListOrders',
        'ViewOrder',
        'UpdateOrder',
        'CancelOrder',
        'CopyOrder',
        'ShowOrderAuditHistory',
        'CreateOrderNotification',
        'ListOrderComments',
        'CreateOrderComment',
        'DeleteOrderComment',
        'ListOrderTasks',
        'ShowOrderTask',
        'CreateOrderTask',
        'ListOrderLineItems',
        'CreateOrderLineItem',
        'ViewLineItem',
        'UpdateLineItem',
        'CancelLineItem',
        'CopyLineItem',
        'ViewFlight',
        'UpdateFlight',
        'CancelFlight',
        'CopyFlight',
        'ShowLineItemAuditHistory',
        'ShowLineItemDownloadPdf',
        'UpdateLineItemCampaignManager',
        'ListLineItemComments',
        'CreateLineItemComment',
        'DeleteLineItemComment',
        'ListLineItemTasks',
        'ShowLineItemTask',
        'CreateLineItemTask'
    )
}]);